import { FC, useEffect, useState } from "react";
import HomeIcon from "../assets/home.svg";
import ProfileIcon from "../assets/profile.svg";
import TopicsIcon from "../assets/topics.svg";
import UsersIcon from "../assets/users.svg";
import { WalletMultiButton } from "@solana/wallet-adapter-react-ui";
import { NavLink, useParams } from "react-router-dom";
require("@solana/wallet-adapter-react-ui/styles.css");

const NavBar: FC = () => {
  const params = useParams();
  const [userid, setUserid] = useState<string | undefined>("#");
  const [topics, setTopicsId] = useState<string | undefined>("#");
  const [profileid, setProfileid] = useState<string | undefined>("#");

  const [windowWidth, setWindowWidth] = useState(window?.innerWidth);

  useEffect(() => {
    if (windowWidth !== window.innerWidth) {
      setWindowWidth(window.innerWidth);
    }
  }, [windowWidth]);

  useEffect(() => {
    if (params.userid) {
      setUserid(params.userid);
    } else {
      setUserid("#");
    }

    if (params.topics) {
      setTopicsId(params.topics);
    } else {
      setTopicsId("#");
    }

    if (params.profileid) {
      setProfileid(params.profileid);
    } else {
      setProfileid("#");
    }


  }, [params]);
  const activeLinksStyles = (isActive: boolean) => {
    return {
      textDecoration: isActive ? "underline" : "",
      textUnderlineOffset: isActive ? "4px" : "",
      textDecorationColor: isActive ? "#60a5fa" : "",
      textDecorationThickness: isActive ? "4px" : "",
      scale: isActive ? "1.2" : "",
      transition: isActive ? "ease-in-out" : "",
      transitionDuration: isActive ? "100ms" : "",
      transitionDelay: isActive ? "150ms" : "",
    };
  };

  return (
    <>
      <nav className="w-max col-start-1 space-y-24 h-screen pt-12 shadow shadow-gray-300 pb-2 px-2 hover:bg-blend-darken fixed md:col-span-12 md:col-start-1 md:flex md:h-fit md:space-y-0 md:pt-2 md:w-full md:justify-around md:items-baseline md:bg-white">
        <NavLink
          to={"/"}
          style={({ isActive }) => activeLinksStyles(isActive)}
          className="flex items-center justify-center cursor-pointer hover:underline decoration-blue-400 decoration-4 underline-offset-4 transition ease-in-out duration-100 hover:scale-110"
        >
          <button className="flex lg:items-center border-b-4 border-blue-400 md:border-none">
            <img
              alt="home icon"
              className="w-fit h-6 lg:h-8"
              src={HomeIcon}
            ></img>
            <span className="text-base ps-0.5 hidden md:inline lg:text-lg">
              Home
            </span>
          </button>
        </NavLink>

        <NavLink
          to={`/topic/${topics}`}
          style={({ isActive }) => activeLinksStyles(isActive)}
          className="flex items-center h-fit justify-center cursor-pointer hover:underline decoration-blue-400 decoration-4 underline-offset-4 transition ease-in-out duration-100 hover:scale-110 "
        >
          <button className="flex lg:items-center border-b-4 border-blue-400 md:border-none">
            <img
              alt="home icon"
              className="w-fit h-6 lg:h-8"
              src={TopicsIcon}
            ></img>
            <span className="text-base ps-0.5 hidden md:inline lg:text-lg">
              Topics
            </span>
          </button>
        </NavLink>

        <NavLink
          to={`/user/${userid}`}
          style={({ isActive }) => activeLinksStyles(isActive)}
          className="flex items-center h-fit justify-center cursor-pointer hover:underline decoration-blue-400 decoration-4 underline-offset-4 transition ease-in-out duration-100 hover:scale-110"
        >
          <button className="flex lg:items-center border-b-4 border-blue-400 md:border-none">
            <img
              alt="home icon"
              className="w-fit h-6 lg:h-8"
              src={ProfileIcon}
            ></img>
            <span className="text-base ps-0.5 hidden md:inline lg:text-lg">
              Users
            </span>
          </button>
        </NavLink>

        <NavLink
          to={`/profile/${profileid}`}
          style={({ isActive }) => activeLinksStyles(isActive)}
          className="flex items-center h-fit justify-center cursor-pointer hover:underline decoration-blue-400 decoration-4 underline-offset-4 transition ease-in-out duration-100 hover:scale-110"
        >
          <button className="flex lg:items-center border-b-4 border-blue-400 md:border-none">
            <img
              alt="home icon"
              className="w-fit h-6 lg:h-8"
              src={UsersIcon}
            ></img>
            <span className="text-base ps-0.5 hidden md:inline lg:text-lg">
              Profile
            </span>
          </button>
        </NavLink>

        {windowWidth >= 768 && <WalletMultiButton />}
      </nav>
    </>
  );
};

export default NavBar;
